import { useAppDispatch } from '@/Application/Hooks/Redux';
import type { IOrderIntentResponse } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import { setKioscoOrderIntent } from '@/modules/perseo-billing/store/slices/billing';

export function useOnCreateIntentSuccessInKiosco() {
  const dispatch = useAppDispatch();

  const handleKioscoSuccess = (data: IOrderIntentResponse) => {
    dispatch(setKioscoOrderIntent(data));
  };

  return { handleKioscoSuccess };
}
